import React from 'react';
import { Box, Button } from '../../../../common/components';
import { hasPermission } from '../../../auth/redux/authActions';
import { ICON_MAP } from '../../../../common/components/SvgIcons/productIcons';
import './NewCustomer.scss';

const GetAQuoteButton = ({ handleNewQuoteButton, product }) => {
  if (!hasPermission('policy.quote')) {
    return null;
  }

  const onNewQuote = () => {
    handleNewQuoteButton(product);
  };

  if (hasPermission('policy.quote')) {
    return (
      <div className="text-center">
        <Button
          id={`get-a-${product.attributes.product_code.toLowerCase()}-quote-btn`}
          handleClick={onNewQuote}
          className="btn-padding-large btn-block"
          bsStyle="primary"
          label={`Get a ${product.attributes.name} Quote`}
          leftSVG={ICON_MAP[product.attributes.product_code]}
        />
      </div>
    );
  }

  return null;
};
const NewCustomer = ({ handleNewQuoteButton, products }) => {
  const handleButton = (product) => {
    handleNewQuoteButton(product);
  };

  return (
    <>
      <div className="dashboard-width-100 get-quotes-header">
        <h3> New Customer - Get a Quote </h3>
      </div>
      <Box className="quotes-box dashboard-new-customer  adjust-height" minHeight>
        <div className="in-quote-box">
          <div className="nav nav-pills nav-stacked row">
            <div className="search-title quote-buttons-container col-xs-12">
              {products.map((product) => (
                <GetAQuoteButton handleNewQuoteButton={handleButton} product={product} />
              ))}
            </div>
          </div>
        </div>
      </Box>
    </>
  );
};

export default NewCustomer;
